import ThankYouPage from "@/components/ThankYouPage";

const MerciAppelAccompagnement = () => (
  <ThankYouPage
    eventName="Lead"
    contentName="Appel découverte · Accompagnement"
    title="C'est confirmé."
    body={`Vous allez recevoir une invitation par courriel avec le lien de la rencontre.

Préparez vos objectifs de croissance pour les douze prochains mois, on va partir de là.`}
    backTo="/accompagnement"
    backLabel="Retour à l'accompagnement"
    canonical="/merci/appel-accompagnement"
  />
);

export default MerciAppelAccompagnement;
